import { sendOrderAjax } from "../../api/checkout";

export default {
    state: {
        steps: [
            {
                id: "1",
                componentName: "delivery",
                disabled: true,
                valid: false,
            },
            {
                id: "2",
                componentName: "customer",
                disabled: true,
                valid: false,
            },
            {
                id: "3",
                componentName: "payment",
                disabled: true,
                valid: false,
            },
            {
                id: "4",
                componentName: "comment",
                disabled: true,
                valid: true,
            }
        ],
        isAuthorize: false,
        isAdmin: (window.arResult) ? window.arResult.isAdmin : false,
        loading: false,
        props: [],
        errorMessages: {
            required: "Поле обязательно для заполнения",
			email: "Укажите электронную почту",
            minlength: "Минимум {0} символов"
        },
        extra: [],
        sessid: (window.arResult) ? window.arResult.sessid : "",
        city: (window.arResult) ? window.arResult.city : "",
        dadataToken: window.dadataApiToken,
        requestData: {},
    },
    mutations: {
        setStepValidState(state, {stepId, value}) {
            const step = state.steps.find(step => step.id === stepId);
            step.valid = value;
        },
        setStepDisabledState(state, {stepId, value}) {
            const step = state.steps.find(step => step.id === stepId);
            step.disabled = value;
        },
        setProps(state, props) {
            state.props = props.map(prop => {
                const oldProp = state.props.find(old => prop.code === old.code);
                if (oldProp && (oldProp.name !== prop.name)) {
                    prop.value = oldProp.value;
                }
                return prop;
            });
        },
		setCity(state, city) {
			state.city = city;
		},
		setSessidId(state, sessid) {
			state.sessid = sessid;
		},
        setExtra(state, extra) {
            state.extra = extra;
        },
        setLoadingStatus(state, status) {
            state.loading = status;
        },
        setRequestData(state, data) {
            state.requestData = data;
        },
        setIsAuthorize(state, value) {
            state.isAuthorize = value;
        }
    },
    actions: {
        setData({commit, getters}, data) {
			commit("setCity", data.city);
			commit("setSessidId", data.sessid);
            commit("setProps", data.props);
            commit("setExtra", data.extra);
            commit("setIsAuthorize", data.isAuthorize);
            commit("delivery/setDelivery", data.delivery, {root: true});
            commit("delivery/setProps", getters.filteredProps("DELIVERY"), {root: true});
            commit("payment/setPaySystem", data.paySystem, {root: true});
            commit("customer/setPersonType", data.personType, {root: true});
            commit("customer/setProps", getters.filteredProps("CUSTOMER"), {root: true});
            commit("summary/setProducts", data.products, {root: true});
            commit("summary/setTotal", data.total, {root: true});
            commit("summary/setServices", data.extra.services, {root: true});
            commit("comment/setProps", getters.filteredProps("COMMENT"), {root: true});
        },
        nextStep({commit, state, getters}, currentStep) {
            const currentStepIndex = state.steps.indexOf(currentStep);
            const nextStep = state.steps[currentStepIndex + 1];
            if (nextStep) {
                commit("setStepDisabledState", {stepId: nextStep.id, value: false});
            }
        },
        blockSteps({commit, state}) {
            const firstInvalidStepIndex = state.steps.findIndex(step => step.valid === false);
            for (let i = firstInvalidStepIndex + 1; i < state.steps.length; i++) {
                commit("setStepDisabledState", {stepId: state.steps[i].id, value: true});
            }
        },
        refreshOrder({commit, dispatch, state}, action = "refreshOrderAjax") {
            return new Promise((resolve, reject) => {
                commit("setLoadingStatus", true);
                dispatch("buildReqeustData", {action});
                sendOrderAjax(state.requestData, data => {
                    if (data.redirectUrl) {
                        window.location.replace(data.redirectUrl);
                    }
                    if (action === "refreshOrderAjax") {
                        dispatch("setData", data);
                        resolve(data);
                    } else {
                        resolve(data);
                    }
                    commit("setLoadingStatus", false);
                });
            });
        },
        buildReqeustData({commit, dispatch, state, rootGetters}, {action}) {
            let data = {
                order: {},
                sessid: state.sessid,
                action
            };
            state.props.forEach(prop => {
                let value = "";
                if (prop.selectedValue) {
                    value = prop.selectedValue;
                } else if (Array.isArray(prop.value)) {
                    let activeValue = prop.value.find(value => value.checked);
                    if (activeValue) {
                        if (activeValue.time) {
                            let time = activeValue.time.find(value => value.checked);
                            if (time) value = `${activeValue.text}/${time.text}`;
                        } else {
                            value = activeValue.id;
                        }
                    }
                 } else {
                    value = prop.value;
                }
                data.order[prop.name] = value;
            });
            data.order["PERSON_TYPE"] = (rootGetters["customer/activePersonType"]) ? rootGetters["customer/activePersonType"].ID : "";
            data.order["DELIVERY_ID"] = (rootGetters["delivery/activeDelivery"]) ? rootGetters["delivery/activeDelivery"].ID : "";
            data.order["PAY_SYSTEM_ID"] = (rootGetters["payment/activePaySystem"]) ? rootGetters["payment/activePaySystem"].ID : "";
            commit("setRequestData", data);
        },
    },
    getters: {
        steps(state) {
            return state.steps;
        },
        firstDisabledStepIndex(state) {
            return state.steps.findIndex(step => step.disabled);
        },
        allStepsAreValid(state) {
            let result = true;
            for (let step of state.steps) {
                if (!step.valid) {
                    result = false;
                    break;
                }
            }
            return result;
        },
        filteredProps: (state) => (group) => {
            return state.props.filter(prop => prop.group === group);
        },
        firstStepId(state) {
            return (state.steps.length) ? state.steps[0].id : "";
        },
		activeStep(state, getters) {
			return (getters.firstDisabledStepIndex !== -1) ? state.steps[getters.firstDisabledStepIndex - 1] : state.steps[state.steps.length - 1];
		}
    },
    namespaced: true
}
